// extracted by mini-css-extract-plugin
module.exports = {"item":"ExtensionHeaderItem_item__1NQJY"};